import 'intersection-observer';
// For AddressForm autocomplete
// Support for IE 11, Safari 11 and iOS 11

const noop = () => {};

if (typeof window !== 'undefined') {
  // ------------------------------------------------------------
  // querySelector is not supported by Chrome Mobile 78, which is still relevant in the beginning of 2020
  // our usage is just for auto-scroll, so we simply polyfill with an empty function
  if (!document.querySelector) {
    document.querySelector = noop;
  }

  // ------------------------------------------------------------
  // Performance.now() is not available on Android 4, which is not filtered on Sentry
  // https://sentry.io/organizations/prose/issues/1574640740
  if ('now' in performance === false) {
    const nowOffset = performance?.timing?.navigationStart ?? Date.now();
    const nowPolyfill = () => Date.now() - nowOffset;
    window.performance.now = nowPolyfill;
  }

  // ------------------------------------------------------------

  // Alias localStorage on window object to make sure
  // its usable everywhere, even on Safari iOS10 Private
  // browsing mode.
  // Should always use the aliased version everywhere.
  //
  // Returns undefined to all methods except to getItem as described
  // https://developer.mozilla.org/en-US/docs/Web/API/Storage
  try {
    // Sniff feature to make sure we detect localStorage presence
    const sentinel = '___fake_key___';
    window.localStorage.setItem(sentinel, sentinel);
    window.localStorage.removeItem(sentinel);
    window._localStorage = window.localStorage;
  } catch (_error) {
    let data = {};
    window._localStorage = {
      setItem(id, val) {
        const stringVal = String(val);
        data[id] = stringVal;
      },
      getItem(id) {
        return id in data ? data[id] : null;
      },
      removeItem(id) {
        delete data[id];
      },
      clear() {
        data = {};
      },
    };
  }
}
